export const MAX_AGENT_FILE_SIZE_MB = 50;
export const MAX_AGENT_FILE_SIZE_BYTES = MAX_AGENT_FILE_SIZE_MB * 1024 * 1024;
export const MAX_AGENT_FILES_PER_UPLOAD = 10;
export const MAX_AGENT_KNOWLEDGE_BASE_SIZE_GB = 5;
export const MAX_AGENT_KNOWLEDGE_BASE_SIZE_BYTES =
	MAX_AGENT_KNOWLEDGE_BASE_SIZE_GB * 1024 * 1024 * 1024;
export const ALLOWED_AGENT_FILE_EXTENSIONS = ['.csv', '.md', '.markdown', '.pdf', '.txt'] as const;
